<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
    class="categories-dialog"
  >
    <template #header>
      Ordenar categorías
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i>
    </template>

    <div class="col-12">
      <OrderCategories ref="orderCategoriesRef" :categories="categories" />
    </div>

    <template #footer>
      <div class="col-12">
        <div class="flex justify-content-between flex-wrap gap-3">
          <Button label="Cancelar" severity="secondary" @click="closeModal()" />
          <Button
            label="Guardar"
            @click="save"
            :loading="loading"
            loading-icon="pi pi-spinner"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";

import {
  categoriesListAll,
  categoriesUpdateOrder,
} from "@/api/categories/categories.api.js";
import OrderCategories from "@/pages/_root/order-categories-dialog/OrderCategories.vue";

// #region Props, Emits
const emit = defineEmits(["saved"]);
// #endregion

// #region Params, Ref, Reactives, Computed
const loading = ref(false);
const orderCategoriesRef = ref(null);
const store = useStore();
const confirm = useConfirm();
const toast = useToast();
const showModalRef = ref(false);
const categories = ref([]);
// #endregion

// #region Functions
async function showModal() {
  categories.value = await categoriesListAll();
  showModalRef.value = true;
  return;
}

async function save() {
  loading.value = true;
  let firstCategory = JSON.parse(
    JSON.stringify(orderCategoriesRef.value.firstCategory)
  );
  let categorySort = JSON.parse(JSON.stringify(orderCategoriesRef.value.list));

  categorySort = categorySort.map((category, index) => {
    delete category.titulo;
    return {
      aliasCategoria: category.aliasCategoria,
      orden: index + 1,
    };
  });

  // Push the first category to the first position
  categorySort.unshift({
    aliasCategoria: firstCategory.aliasCategoria,
    orden: 0,
  });

  let response = await categoriesUpdateOrder(categorySort);

  if (response.status == 200) {
    toast.add({
      severity: "success",
      summary: `Orden actualizado`,
      detail: `Se ha actualizado el orden de las categorías correctamente`,
      life: 3000,
    });

    emit("saved");

    showModalRef.value = false;
  } else {
    const error = response.response?.data?.errors?.[0]?.message;

    if (!error) {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: `No se ha podido actualizar el orden de las categorías`,
        life: 3000,
      });
    } else {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
    }
  }

  loading.value = false;
}

function closeModal() {
  let showConfirm = false;

  const list = orderCategoriesRef.value.list;

  // check if the order has changed
  for (let i = 0; i < list.length; i++) {
    if (list[i].orden != categories.value[i].orden) {
      showConfirm = true;
      break;
    }
  }

  if (showConfirm) {
    confirm.require({
      message:
        "Se ha modificado el orden de las categorías, ¿desea salir sin guardar?",
      header: "Cerrar pantalla",
      icon: "pi pi-exclamation-triangle",
      rejectClass: "p-button-secondary p-button-outlined",
      accept: async () => {
        showModalRef.value = false;
      },
    });
  } else {
    showModalRef.value = false;
  }
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
